import { Injectable, Type } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { SideBarInitializeParameters } from "src/app/shared/components/dynamic-right-sidebar/SideBarInitializeParameters";
import { CodeTable, CodeTableListResult } from "../../model/v2/code-table";
import { SearchSupportRequestReq } from "../../../core/models/searchSupportRequestList";
import { BaseService } from "../shared/base.service";
import { shareReplay } from "rxjs/operators";
import { ResultBase } from "../../models/result-base";
import { ServiceToOffer } from "../../models/healthSystem/serviceToOffer";

@Injectable({
  providedIn: "root",
})
export class CommonService {
  supportRequestOpened = false;

  rightSideBarComponent$ = new Subject<SideBarInitializeParameters>();
  closeRightSideBar$ = new Subject<void>();
  togglePatientProfileSidebar: boolean = false;

  constructor(private baseService: BaseService) { }

  getLanguages(): Observable<any> {
    return this.baseService.get<any>(`Common/GetLanguages`);
  }
  getSpecialty(categoryId: number = 0): Observable<any> {
    return this.baseService.get<any>(`Common/GetSpecialties?categoryId=${categoryId}`);
  }
  GetSpecialtyCategories(catId: number = 0, subCatId: number = 0): Observable<any> {
    return this.baseService.get<any>(`Common/GetSpecialtyCategories?specialityCategoryid=${catId}`);
  }
  GetLocationByZipcode(searchTerm: string): Observable<any> {
    return this.baseService.get<any>(`Common/GetLocationByZipcode?searchString=${searchTerm}`);
  }
  GetSpecialization(parentId: number = 0): Observable<any> {
    return this.baseService.get<any>(`Common/GetSubSpecialties?parentId=${parentId}`);
  }
  GetSpecializationsBySubCategory(subCategoryIds: number[]): Observable<any> {
    return this.baseService.post<any>(`Common/GetSpecializationsBySubCategory?specializationCategoryid`, subCategoryIds);
  }
  GetFindCareTeam(searchParams: any): Observable<any> {
    return this.baseService.post<any>(`Common/SearchForProvidersBySpeciality`, searchParams);
  }

  SearchForProvidersByGivenCriteria(searchParams: any): Observable<any> {
    return this.baseService.post<any>(`Common/SearchForProvidersByGivenCriteria`, searchParams);
  }

  getSpecializationCategories(specializationCategoryid: number): Observable<any> {
    return this.baseService.get<any>(`Common/GetSpecializationCategories?specializationCategoryid=${specializationCategoryid}`);
  }
  getInsurances(): Observable<any> {
    return this.baseService.get<any>(`Common/GetInsurances`);
  }
  updateEmployerInsurances(data) {
    return this.baseService.post<any>(
      `Employer/UpdateEmployerInsurancePlans`,
      data
    );
  }
  getEmployerInsurancePlans(employerid: number): Observable<any> {
    return this.baseService.get<any>(`Employer/GetEmployerInsurancePlans?employerid=${employerid}`);
  }
  getServiceTypes(): Observable<any> {
    return this.baseService.get<any>(`Common/GetServiceTypes`);
  }

  supportRequest(
    issuetype: string,
    description: string,
    files: any[]
  ): Observable<any> {
    const docForm: FormData = new FormData();
    files.forEach((file) => {
      docForm.append("Attachments", file, file.name);
    });

    docForm.append("Description", description);
    docForm.append("SupportType", issuetype);

    return this.baseService.upload<any>(`SupportRequest`, docForm);
  }

  completeSupportRequest(reqId: number): Observable<any> {
    return this.baseService.post<any>(
      `SupportRequest/CompleteSupportRequest?supportRequestId=${reqId}`,
      null
    );
  }

  searchSupportRequests(req: SearchSupportRequestReq): Observable<any> {
    return this.baseService.post<any>(
      `SupportRequest/SearchSupportRequests`,
      req
    );
  }

  allCodes$: Observable<any>;

  //this method depend that getItemsForAllCodeNames been completed before and cached allCodes...
  getItemCodesFiltered(code: string): CodeTable {
    var codeTables;
    this.getItemsForAllCodeNames().subscribe(
      (codes) => {
        codeTables = codes;
      },
      (error) => {
        console.error(error);
      }
    );

    return codeTables && codeTables.codeTable
      ? codeTables.codeTable.filter((obj) => obj.codeName === code)[0]
      : null;
  }

  getItemsForAllCodeNames(): Observable<any> {
    if (!this.allCodes$)
      this.allCodes$ = this.requestItemsForAllCodeNames().pipe(shareReplay(50));

    return this.allCodes$;
  }

  GetStatesWithoutCache(): Observable<CodeTableListResult> {
    return this.baseService.anonymousGet<CodeTableListResult>(
      `Common/GetStates`
    );
  }


  GetItemsByCodeNamesWithoutCache(
    codeNames: string[]
  ): Observable<CodeTableListResult> {
    return this.baseService.post<CodeTableListResult>(
      `Common/GetItemsByCodeNames`,
      codeNames
    );
  }

  clearAllCodesCache() {
    this.allCodes$ = null;
  }

  private requestItemsForAllCodeNames(): Observable<any> {
    return this.baseService.get<any>(`Common/GetItemsForAllCodeNames`);
  }

  getPharmacyDetails(pharmacyName: string, zipCode: string): Observable<any> {
    return this.baseService.get<any>(
      `Common/GetPharmacyDetailsByZipCode?zipCode=${zipCode}&pharmacyName=${pharmacyName}`
    );
  }
  getServicesToOffer(): Observable<ResultBase<ServiceToOffer[]>> {
    return this.baseService.get<ResultBase<ServiceToOffer[]>>(
      `Common/GetServicesToOffer`
    );
  }

  uploadNPIData(data: FormData): Observable<any> {
    return this.baseService.upload<any>('Common/UploadNPIData', data);
  }
  getDynamicSearchApiData(apiUrl: string): Observable<any> {
    return this.baseService.get<any>(
      `${apiUrl}`
    );
  }
  getUserRoles(): Observable<any> {
    return this.baseService.get<any>(
      `Common/GetUserRoles`
    );
  }


}
